export class UpdateServiceMessage {
  allowDiscounts: boolean
  description: string
  name: string
  price: number
  sku: string

  constructor(allowDiscounts: boolean, description: string, name: string, price: number, sku: string) {
    this.allowDiscounts = allowDiscounts
    this.description = description
    this.name = name
    this.price = price
    this.sku = sku
  }
}